export var ReadFlags = function (flags, flag) {
    var _a;
    return (_a = flags.find(function (f) { return f.name === flag; })) === null || _a === void 0 ? void 0 : _a.value;
};
